import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { coreFeatureFlagEffects } from '@opengov/app-core/featureFlag';

type FeatureFlagsContextType = Record<string, boolean>;

const FeatureFlagsContext = createContext<FeatureFlagsContextType>({});

interface FeatureFlagsProviderProps {
  children: React.ReactNode;
  entityFriendlyId?: string;
}

export const FeatureFlagsProvider: React.FC<FeatureFlagsProviderProps> = ({ children, entityFriendlyId }) => {
  const [flags, setFlags] = useState<FeatureFlagsContextType>({});
  const [isInitialized, setIsInitialized] = useState(false);
  const previousEntityFriendlyIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const hasEntityFriendlyIdChanged = previousEntityFriendlyIdRef.current !== entityFriendlyId;
    const shouldFetchFlags = !isInitialized || hasEntityFriendlyIdChanged;

    if (shouldFetchFlags) {
      void coreFeatureFlagEffects.getFlags({ entityFriendlyId }).then((fetchedFlags) => {
        setFlags(fetchedFlags as FeatureFlagsContextType);
        setIsInitialized(true);
        previousEntityFriendlyIdRef.current = entityFriendlyId;
      });
    }
  }, [isInitialized, entityFriendlyId]);

  return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>;
};

export const useFeatureFlag = (flagName: string): boolean => {
  const context = useContext(FeatureFlagsContext);
  return context[flagName] ?? false;
};
